import { Page as HablaPage } from '@dixa/lib-shared-habla';
import cx from 'classnames';
import * as React from 'react';

import { Head, HeadBackLink, HeadTitle } from './head';
import s from './page.module.scss';

type Props = {
  className?: string;
  children?: React.ReactNode;
  padding?: string;
  flexDirection?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Page = ({
  className,
  children,
  flexDirection,
  ...otherProps
}: Props): JSX.Element => {
  return (
    <div className={cx(s.root, className)} {...otherProps}>
      {children}
    </div>
  );
};

const HablaPageBody = ({
  children,
  padding,
  flexDirection,
  ...otherProps
}: Props) => (
  <HablaPage.Body className={s.hablaPageBody} {...otherProps}>
    {children}
  </HablaPage.Body>
);
Page.Body = HablaPageBody;
Page.Head = Head;
Page.HeadTitle = HeadTitle;
Page.HeadBackLink = HeadBackLink;
Page.Section = HablaPage.Section;
Page.Tabs = HablaPage.Tabs;

export default Page;
